import type { InstanceType } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/cloud_info_pb";
import type { Instance } from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/instance_pb";
import type { GPUInstanceType } from "types/InstanceTypes";
import { formatByteValue } from "utils/byteValues";
import { normalizeInstanceTypeBytes } from "utils/instanceTypeBytes";

export function getInstanceDiskSize(instance: Instance): string {
  return formatByteValue(instance.diskSizeBytes) ?? instance.diskSize;
}

export function mapInstanceType(instanceType: InstanceType): GPUInstanceType {
  const raw = instanceType.toJson({
    emitDefaultValues: true,
    useProtoFieldName: true,
  }) as unknown as GPUInstanceType;

  return normalizeInstanceTypeBytes(raw);
}
